// directives/teleport-responsive.js
export default function (Alpine) {
  Alpine.directive('teleport-below', (el, { expression, modifiers }, { effect, cleanup }) => {
    const bp = modifiers[0]; // e.g., 'md', 'lg'
    const target = document.querySelector(expression);
    if (!target) return;

    const original = el.parentElement;
    const placeholder = document.createComment('teleport-below');

    // Store original position
    original.insertBefore(placeholder, el);

    effect(() => {
      const shouldTeleport = Alpine.store('screen').below(bp);

      if (shouldTeleport) {
        target.appendChild(el);
      } else {
        placeholder.parentElement?.insertBefore(el, placeholder.nextSibling);
      }
    });

    cleanup(() => {
      placeholder.parentElement?.insertBefore(el, placeholder.nextSibling);
      placeholder.remove();
    });
  });
}
